import { EuroValue } from '@dokucoach/common-types';
import { boolean, date, object, ref, string } from 'yup';

export type IResidentMonthlyIncomingFund = {
  id: string;
  nursingHomeId: string;
  residentId: string;
  label: string;
  amount: number;
  incomingFrom: Date;
  incomingUntil: Date | null;
  remark: string | null;
  isActive: boolean;
};

export type IResidentMonthlyIncomingFundCreate = {
  label: string;
  amount: number;
  incomingFrom: Date;
  incomingUntil?: Date | null;
  remark?: string | null;
  isActive: boolean;
};

export const IResidentMonthlyIncomingFundCreateSchema = object({
  label: string().required(),
  amount: EuroValue.required(),
  incomingFrom: date().required(),
  incomingUntil: date().nullable().optional().min(ref('incomingFrom')).default(null),
  remark: string().nullable().optional(),
  isActive: boolean().required(),
});

export type IResidentMonthlyIncomingFundUpdate = {
  incomingUntil?: Date | null;
  remark?: string | null;
  isActive?: boolean;
};

export const IResidentMonthlyIncomingFundUpdateSchema = object({
  incomingUntil: date().nullable().optional(),
  remark: string().nullable().optional(),
  isActive: boolean().nullable().optional(),
});
